/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AsCodeCustomMetadataEntryValueReferenceDto = {
    customMetadataName?: string;
    kind: AsCodeCustomMetadataEntryValueReferenceDto.kind;
};

export namespace AsCodeCustomMetadataEntryValueReferenceDto {

    export enum kind {
        LABEL = 'Label',
        STRING = 'String',
        USER = 'User',
        TEAM = 'Team',
    }


}
